export const apiConfigUrl = process.env.REACT_APP_GRAPHQL_URL;


export const Web_Base_Url = process.env.REACT_APP_WEB_BASE_URL;

export const captchaSiteKey = process.env.REACT_APP_CAPTCHA_SITE_KEY;
export const captchaSiteKeyV2 = process.env.REACT_APP_CAPTCHA_SITE_KEY_V2;


export const config = {

    STRIPE_PUBLIC_KEY: process.env.REACT_APP_STRIPE_PUBLIC_KEY,
    RYFT_PUBLIC_KEY: process.env.REACT_APP_RYFT_PUBLIC_KEY,
};
export const isRedictToTeamsBookingLink = process.env.REACT_APP_IS_REDIRECT_TO_TEAMS_BOOKING_URL;
